import { useMemo } from 'react';
import { useOrgConfigStateValue } from './business/useOrgConfig';
import { isTfsoftware } from 'productLine';

export const useTFERPEnable = () => {
  const { whiteListConfig } = useOrgConfigStateValue();

  const enable = useMemo(() => {
    const whiteList = whiteListConfig?.TF_ERP_ENABLE ?? false;

    return isTfsoftware || whiteList;
  }, [whiteListConfig]);

  return enable;
};
